import { Vector3 } from 'three';

export type CameraTravelPathNode = {
  eye: Vector3;
  target: Vector3;
};

export class CameraTravelPath {
  nodes: CameraTravelPathNode[] = [];
  constructor(nodes?: CameraTravelPathNode[]) {
    this.nodes = nodes ?? [];
  }

  getLength() {
    if (this.nodes.length < 2) return 0;
    let length = 0;
    for (let i = 1; i < this.nodes.length; i++) {
      length += this.nodes[i - 1].eye.distanceTo(this.nodes[i].eye);
    }
    return length;
  }
}
